import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Grid, Hidden, CircularProgress, TextField } from '@material-ui/core'
import { Link, useLocation } from 'react-router-dom'
import { devices } from 'utils/screen_sizes'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useTranslation } from 'react-i18next'
import { API_KEY, API_SECRET, makeHttpRequest } from 'utils/api_utils'
const StyledFooter = styled.div`
    color: #fff;
    // width: 80vw;
    margin: 0 auto;
    padding: 2rem 0;

    @media ${devices.mobileS} {
        width: 90vw;
    }
    @media ${devices.laptop} {
        width: 90vw;
    }
    p {
        font-size: 14px;
        margin-bottom: 2.5rem;
        opacity: 0.8;
    }
`
const validationSchema = yup.object({
    name: yup.string('Enter your Name').required('Name is required'),
    occupation: yup
        .string('Enter your Occupation ')
        .required('Occupation is required'),
    testimonial: yup
        .string('Enter your Testimonial')
        .required('Testimonial is required'),
})
const StyledFooterList = styled.ul`
    margin: 0;
    list-style-type: none;
    padding: 0;

    li {
        font-size: 12px;
        margin: 10px 0;
        opacity: 0.8;

        a {
            text-decoration: none;
            color: #fff;
            cursor: pointer;
        }
    }
`
const FooterTitle = styled.h4`
    font-weight: normal;
    font-size: 15px;
    margin-top: 0;
    margin-bottom: 0;
`

const StyledFooterSocials = styled.div`
    display: flex;
    a {
        padding: 5px;
    }
    i {
        font-size: 25px;
        color: #fff;
    }
`

const Footer = ({ aboutScrollRef, storeScrollRef }) => {
    const { pathname } = useLocation()
    const { t } = useTranslation()
    const [country, setCountry] = useState('')
    const [counStore, setCountryStore] = useState('')
    const [open, setOpen] = React.useState(false)
    // let country = getCountryFromUrl(pathname) || 'ke'
    const [isPostingWarranty, setIsPostingWarranty] = useState(false)
    const [message, setMessage] = useState({
        msg: '',
        severity: '',
    })
    const formik = useFormik({
        initialValues: {
            occupation: '',
            name: '',
            testimonial: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setIsPostingWarranty(true)

            let reqObj = {
                name: values.name,
                occupation: values.occupation,
                testimonial: values.testimonial,
                country: country,
            }
            fetch(`${process.env.REACT_APP_API_URL}new_testimonial`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Key: API_KEY,
                    Secret: API_SECRET,
                    country: localStorage.getItem('country') || 'ke',
                },
                body: JSON.stringify(reqObj),
            })
                .then((response) => response.json())
                .then(({ success, msg }) => {
                    if (success) {
                        setMessage({
                            ...message,
                            msg: msg,
                            severity: 'success',
                        })
                        setOpen(false)
                        setIsPostingWarranty(false)
                        formik.resetForm()
                    } else {
                        setMessage({ ...message, msg: msg, severity: 'error' })
                        setIsPostingWarranty(false)
                    }
                })
                .catch((error) => {
                    console.error('Error:', error)
                    setMessage({ ...message, msg: message, severity: 'error' })
                    setIsPostingWarranty(false)
                })
        },
    })
    const handleClose = () => {
        setOpen(false)
    }
    useEffect(() => {
        if (window.location.hostname === 'sell.badili.ke') {
            setCountry('ke')
            setCountryStore('https://badili.ke/')
        } else if (window.location.hostname === 'sell.badili.co.tz') {
            setCountryStore('https://badili.co.tz/')
            setCountry('tz')
        } else if (window.location.hostname === 'sell.badili.ug') {
            setCountryStore('https://badili.ug/')
            setCountry('ug')
        } else {
            setCountryStore('https://badili.ke/')
            setCountry('ke')
        }
    }, [])
    // const executeAboutScroll = () =>
    //     aboutScrollRef.current.scrollIntoView({ block: 'end' })
    // const executeStoreScroll = () =>
    //     storeScrollRef.current.scrollIntoView({ block: 'end' })

    const openTestimonialModal = () => setOpen(true)
    return (
        <StyledFooter>
            {/* <p>
                Hello! We're Badili Africa, the leading re-commerce for renewed
                devices. Our mission? To fight e-waste by giving expertly
                restored devices a second life
            </p> */}
            <Hidden mdDown>
                <Grid container spacing={3}>
                    {/* <Grid item xs={12} sm={2}>
                        <FooterTitle></FooterTitle>
                        Hello! We're Badili Africa, the leading re-commerce for renewed
                devices. Our mission? To fight e-waste by giving expertly
                restored devices a second life
                    </Grid> */}
                    <Grid item xs={12} sm={3}>
                        <>
                            {' '}
                            <img
                                src={
                                    '/assets/images/Badili1-footer-preview.svg'
                                }
                                alt=""
                                height="100%"
                                width="35%"
                                style={{ marginBottom: '-29px' }}
                            />
                        </>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FooterTitle style={{ marginTop: '25px' }}>
                            {t('description.footer_menu_about_title')}
                        </FooterTitle>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FooterTitle style={{ marginTop: '25px' }}>
                            {t('description.footer_menu_Help')}
                        </FooterTitle>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FooterTitle style={{ marginTop: '25px' }}>
                            {t('description.footer_menu_Legal')}
                        </FooterTitle>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FooterTitle style={{ marginTop: '25px' }}>
                            {t('description.footer_menu_Social')}
                        </FooterTitle>
                    </Grid>
                </Grid>
            </Hidden>

            <Grid container spacing={3} style={{ padding: '0px' }}>
                <Grid item xs={12} sm={3}>
                    <Hidden mdUp>
                        <FooterTitle>
                            {' '}
                            <>
                                {' '}
                                <img
                                    src={
                                        '/assets/images/Badili1-footer-preview.svg'
                                    }
                                    alt=""
                                    height="100%"
                                    width="35%"
                                    style={{ marginBottom: '-29px' }}
                                />
                            </>
                        </FooterTitle>
                    </Hidden>

                    <StyledFooterList
                        style={{
                            color: 'rgba(255, 255, 255, 0.70)',
                            fontFamily: 'Open Sans',
                            fontSize: '12px',
                        }}
                    >
                        {t('description.footer_bottom_desc')}
                    </StyledFooterList>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Hidden mdUp>
                        <FooterTitle>
                            {t('description.footer_menu_about_title')}
                        </FooterTitle>
                    </Hidden>

                    <StyledFooterList
                        style={{
                            marginTop: '-6px',
                        }}
                    >
                        {/* <li>
                            
                            <HashLink
                                to={`/${country}/#about`}
                                scroll={(el) =>
                                    el.scrollIntoView({
                                        behavior: 'auto',
                                        block: 'end',
                                    })
                                }
                            >
                                {t('description.footer_menu_about_about_us')}
                            </HashLink>
                        </li> */}
                        <li>
                            {/* <Link to={`/${country}/ecommerce/shop`}> */}
                            <a href={counStore}>
                                {t('description.footer_menu_Buy_Phone_from_Us')}
                            </a>
                            {/* </Link> */}
                        </li>
                        {/* <li>
                            <Link to="/"> Trade-in</Link>
                        </li> */}
                        {/* <li>
                            <HashLink
                                to={`/${country}/#stores`}
                                scroll={(el) =>
                                    el.scrollIntoView({
                                        behavior: 'auto',
                                        block: 'end',
                                    })
                                }
                            >
                               {t('description.footer_menu_badili_Stores')}
                            </HashLink>
                        </li> */}
                        <li>
                            {/* <Link to={`/${country}/careers`}>Careers</Link> */}
                            <Link to={`/${country}/careers`}>
                                {t('description.footer_menu_about_careers')}
                            </Link>
                        </li>
                        {/* <li>
                            <Link to="/">Careers</Link>
                        </li> */}
                        {/* <li>
                            <a href onClick={openRepairModal}>
                                Repair Pro
                            </a>
                        </li> */}
                    </StyledFooterList>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Hidden mdUp>
                        <FooterTitle>
                            {t('description.footer_menu_Help')}
                        </FooterTitle>
                    </Hidden>

                    <StyledFooterList
                        style={{
                            marginTop: '-6px',
                        }}
                    >
                        <li>
                            <Link to={`/${country}/dealers/register`}>
                                {t(
                                    'description.footer_menu_how_to_Become_A_Dealer'
                                )}
                            </Link>
                        </li>
                        <li>
                            <Link to={`/${country}/register-phone`}>
                                {t('description.footer_menu_Warranty')}
                            </Link>
                        </li>

                        {/* <li>
                            <Link to="/">{t('description.footer_menu_Contact_Us')}</Link>
                        </li> */}
                        <li>
                            <a href="#" onClick={openTestimonialModal}>
                                {t('description.footer_menu_Post_Testimonial')}
                            </a>
                        </li>
                    </StyledFooterList>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Hidden mdUp>
                        <FooterTitle>
                            {t('description.footer_menu_Legal')}
                        </FooterTitle>
                    </Hidden>

                    <StyledFooterList
                        style={{
                            marginTop: '-6px',
                        }}
                    >
                        <li>
                            <Link to={`/${country}/how-it-works?2`}>
                                {t('description.footer_menu_Privacy_Policy')}
                            </Link>
                        </li>
                        <li>
                            <Link to={`/${country}/how-it-works?1`}>
                                {t(
                                    'description.footer_menu_Terms_and_Conditions'
                                )}
                            </Link>
                        </li>
                        <li id="returnPolicy">
                            <Link to={`/${country}/how-it-works?3`}>
                                {t('description.footer_menu_Return_Policy')}
                            </Link>
                        </li>
                    </StyledFooterList>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Hidden mdUp>
                        <FooterTitle>
                            {t('description.footer_menu_Social')}
                        </FooterTitle>
                    </Hidden>

                    <StyledFooterList
                        style={{
                            marginTop: '2px',
                        }}
                    >
                        <StyledFooterSocials>
                            <a href="https://twitter.com/badili_africa">
                                <i className="fab fa-twitter-square"></i>
                            </a>
                            <a href="https://www.facebook.com/badili.africa">
                                <i className="fab fa-facebook"></i>
                            </a>
                            <a href="https://www.instagram.com/badili_africa/">
                                <i className="fab fa-instagram"></i>
                            </a>
                            <a href="https://www.youtube.com/channel/UCQPgE8WmL8KmyYsQ85GGZlg">
                                <i className="fab fa-youtube"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/badili-commerce">
                                <i className="fab fa-linkedin"></i>
                            </a>
                        </StyledFooterSocials>
                    </StyledFooterList>
                </Grid>
            </Grid>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{t('description.testimonial_tz')}</DialogTitle>

                <form
                    noValidate
                    autoComplete="off"
                    className="warranty-form"
                    onSubmit={formik.handleSubmit}
                >
                    <DialogContent>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6} md={6}>
                                <TextField
                                    className="mb-4"
                                    label="Full Name"
                                    name="name"
                                    variant="standard"
                                    fullWidth
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.name &&
                                        Boolean(formik.errors.name)
                                    }
                                    helperText={
                                        formik.touched.name &&
                                        formik.errors.name
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <TextField
                                    className="mb-4"
                                    label="Occupation"
                                    variant="standard"
                                    fullWidth
                                    name="occupation"
                                    value={formik.values.occupation}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.occupation &&
                                        Boolean(formik.errors.occupation)
                                    }
                                    helperText={
                                        formik.touched.occupation &&
                                        formik.errors.occupation
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    id="standard-full-width"
                                    label="Testimonial"
                                    variant="standard"
                                    multiline
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    rows={2}
                                    style={{ margin: 8 }}
                                    name="testimonial"
                                    value={formik.values.testimonial}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.testimonial &&
                                        Boolean(formik.errors.testimonial)
                                    }
                                    helperText={
                                        formik.touched.testimonial &&
                                        formik.errors.testimonial
                                    }
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            className="register-warranty-btn"
                            disabled={isPostingWarranty}
                            style={{ backgroundColor: '#58cab9' }}
                        >
                            {isPostingWarranty && (
                                <>
                                    <CircularProgress
                                        size={17}
                                        className={`text-white mr-2 `}
                                    />
                                    Just a moment
                                </>
                            )}
                            {!isPostingWarranty && 'Submit'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </StyledFooter>
    )
}

export default Footer
